import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import CTA from "components/CTA";
import { COLORS } from "utils/styles";
import { CTA_STYLE } from "utils/constants/ui";
import PATHS from "utils/paths";

const RedirectCTA = ({ isAuthed, header }) => {
  const copy = isAuthed ? "the hub" : "the home page";
  const href = isAuthed ? PATHS.HUB : PATHS.HOME;
  const ctaProps = {
    header,
    subheader: `Head back to ${copy}.`,
    actions: [
      {
        copy: `Back to ${copy}`,
        tag: "link",
        href
      }
    ],
    ...CTA_STYLE
  };
  return (
    <div className="h-100 w-100" style={{ backgroundColor: COLORS.whitesmoke }}>
      <main className="ph3 pb3 black-80 h-100">
        <div className="measure center">
          <div className="pv3 pt4-ns dib w-100 ph3 ph0-ns">
            <CTA {...ctaProps} />
          </div>
        </div>
      </main>
    </div>
  );
};

RedirectCTA.propTypes = {
  header: PropTypes.string,
  isAuthed: PropTypes.bool
};

RedirectCTA.defaultProps = {
  header: "Whoops there was an error!"
};

const mapStateToProps = (state) => {
  const userID = state.getIn(["user", "data", "id"]);
  return { isAuthed: Boolean(userID) };
};

export default connect(mapStateToProps, null)(RedirectCTA);
